module.exports = __webpack_public_path__ + "../../../static/img/c_im_31.8140fa38.png";